var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "warehouseReceipt" } }, [
    _vm.deviceType == "tablet" || _vm.deviceType == "desktop"
      ? _c("div", { staticClass: "warehouse_PC" }, [
          _c("div", { staticClass: "warehouse_PC_con" }, [
            _c("div", { staticClass: "warehouse_PC_head" }, [
              _vm._v("入库单确认")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "warehosue_PC_warning" }, [
              _c(
                "div",
                { staticClass: "warehouse_warning_chose" },
                [
                  _vm._v("\n          语言/language:     "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: _vm.languageType == "CN" ? "primary" : "default"
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeLang("CN")
                        }
                      }
                    },
                    [_vm._v("中文")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: _vm.languageType == "EN" ? "primary" : "default"
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeLang("EN")
                        }
                      }
                    },
                    [_vm._v("English")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "warehouse_warn_words" }, [
                _vm._v(
                  "\n          注意:  请务必认真填写货值并提交确认,此信息具有法律效应!\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "warehouse_in_order" }, [
              _c("div", { staticClass: "warehouse_order_choices" }, [
                _c("div", { staticClass: "warehouse_choices_title" }, [
                  _vm._v("入仓单序号(点击查看详情)")
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "warehouse_choices_ul" },
                  _vm._l(_vm.inOrderList, function(item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        class: {
                          warehosue_choices_li: true,
                          active_preview: _vm.previewIndex == index
                        },
                        on: {
                          click: function($event) {
                            return _vm.changePreviewIndex(index)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(index + 1) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "warehouse_orders" },
                _vm._l(_vm.inOrderList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "warehouse_orders_item" },
                    [
                      _c("div", { staticClass: "warehouse_item_title" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              flex: "1",
                              "flex-direction": "row",
                              "align-items": "center"
                            }
                          },
                          [
                            _vm._v(
                              "\n                客户:   " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.customername.en
                                    : item.customername.cn
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "warehouse_value_input" },
                          [
                            _c(
                              "div",
                              { staticClass: "warehouse_value_title" },
                              [_vm._v("货值金额(USD):")]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                disabled: item.jobType.en == "FBA",
                                type: "number",
                                min: 0,
                                clearable: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.handleMoneyInput(
                                    item.valueGoods.en,
                                    index
                                  )
                                }
                              },
                              model: {
                                value: item.valueGoods.en,
                                callback: function($$v) {
                                  _vm.$set(item.valueGoods, "en", $$v)
                                },
                                expression: "item.valueGoods.en"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "warehouse_orders_con" }, [
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("入仓号")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.inNos.en
                                  : item.inNos.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("入仓时间")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.inWarehouseTime.en
                                  : item.inWarehouseTime.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("付款方")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.payType.en
                                  : item.payType.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("清关方式")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.customsType.en
                                  : item.customsType.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("目的国")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.countryName.en
                                  : item.countryName.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("业务类型")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.jobType.en
                                  : item.jobType.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("报关方式")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.declareType.en
                                  : item.declareType.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("货物类型")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.goodsType.en
                                  : item.goodsType.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("件数")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.piece.en
                                  : item.piece.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("重量(KG)")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.weight.en
                                  : item.weight.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("体积(m³)")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.cbm.en
                                  : item.cbm.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("计费重")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.chargWeight.en
                                  : item.chargWeight.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("品名")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.goodsName.en
                                  : item.goodsName.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "warehouse_con_son",
                            staticStyle: { color: "#ee3330" }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.brandName.en
                                      ? item.brandName.en + "、"
                                      : ""
                                    : item.brandName.cn
                                    ? item.brandName.cn + "、"
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.hasbatteryName.en
                                      ? item.hasbatteryName.en + "、"
                                      : ""
                                    : item.hasbatteryName.cn
                                    ? item.hasbatteryName.cn + "、"
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.powderliquidName.en
                                      ? item.powderliquidName.en
                                      : ""
                                    : item.powderliquidName.cn
                                    ? item.powderliquidName.cn
                                    : ""
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("客户单号")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.refno.en
                                  : item.refno.cn
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v("物流单号")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "warehouse_con_son" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.languageType == "EN"
                                  ? item.logisticsNo.en
                                  : item.logisticsNo.cn
                              ) +
                              "\n              "
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "warehouse_PC_bottom" }, [
              _c(
                "div",
                { staticClass: "warehouse_bottom_first" },
                [
                  _c("div", { staticStyle: { color: "rgb(224, 0, 17)" } }, [
                    _vm._v("提交人:")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.submitMan,
                      callback: function($$v) {
                        _vm.submitMan = $$v
                      },
                      expression: "submitMan"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "warehouse_bottom_second" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.submitFormVal(false)
                        }
                      }
                    },
                    [_vm._v("保存")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.submitFormVal(true)
                        }
                      }
                    },
                    [_vm._v("确认并提交")]
                  )
                ],
                1
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.deviceType == "mobile"
      ? _c("div", { staticClass: "warehouse_Mobile" }, [
          _c("div", { staticClass: "warehouse_Mobile_title" }, [
            _vm._v("入库单确认")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "warehouse_Mobile_con" }, [
            _c("div", { staticClass: "warehouse_Mobile_lang" }, [
              _vm._v("\n        语言(Language):\n        "),
              _c(
                "div",
                {
                  class: {
                    Mobile_chose_btn: true,
                    Mobile_btn_active: _vm.mobileLang == "CN"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeMobileLang("CN")
                    }
                  }
                },
                [_vm._v("\n          中文\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    Mobile_chose_btn: true,
                    Mobile_btn_active: _vm.mobileLang == "EN"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeMobileLang("EN")
                    }
                  }
                },
                [_vm._v("\n          English\n        ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "warehouse_inOrder_list" }, [
              _c(
                "ul",
                { staticClass: "warehouse_inOrder_ul" },
                _vm._l(_vm.inOrderList, function(item, index) {
                  return _c(
                    "li",
                    { key: index, staticClass: "warehouse_inOrder_li" },
                    [
                      _c("div", { staticClass: "inOrder_li_cus" }, [
                        _vm._v("客户:Bob(送货收款)")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inOrder_li_money" }, [
                        _c("div", [_vm._v("货值金额")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  disabled: item.jobType.en == "FBA",
                                  type: "number",
                                  clearable: "",
                                  placeholder: "请填写货值金额"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.handleMoneyInput(
                                      item.valueGoods.en
                                    )
                                  }
                                },
                                model: {
                                  value: item.valueGoods.en,
                                  callback: function($$v) {
                                    _vm.$set(item.valueGoods, "en", $$v)
                                  },
                                  expression: "item.valueGoods.en"
                                }
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("USD")
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inOrder_li_form" }, [
                        _c("div", [
                          _c("div", [_vm._v("入仓号")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.inNos.en
                                    : item.inNos.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("入仓时间")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.inWarehouseTime.en
                                    : item.inWarehouseTime.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("付款方")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.payType.en
                                    : item.payType.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("清关方式")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.customsType.en
                                    : item.customsType.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("目的国")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.countryName.en
                                    : item.countryName.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("业务类型")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.jobType.en
                                    : item.jobType.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("报关方式")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.declareType.en
                                    : item.declareType.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("货物类型")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.goodsType.en
                                    : item.goodsType.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("其他属性")]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { color: "#ee3330" } }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.brandName.en
                                      ? item.brandName.en + "、"
                                      : ""
                                    : item.brandName.cn
                                    ? item.brandName.cn + "、"
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.hasbatteryName.en
                                      ? item.hasbatteryName.en + "、"
                                      : ""
                                    : item.hasbatteryName.cn
                                    ? item.hasbatteryName.cn + "、"
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.powderliquidName.en
                                      ? item.powderliquidName.en
                                      : ""
                                    : item.powderliquidName.cn
                                    ? item.powderliquidName.cn
                                    : ""
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("件数")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.piece.en
                                    : item.piece.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("重量(KG)")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.weight.en
                                    : item.weight.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("体积(m³)")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.cbm.en
                                    : item.cbm.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("计费重")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.chargWeight.en
                                    : item.chargWeight.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("品名")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "nowrap",
                                "word-break": "break-all",
                                "text-overflow": "ellipsis",
                                overflow: "hidden"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.languageType == "EN"
                                      ? item.goodsName.en
                                      : item.goodsName.cn
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("客户单号")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.refno.en
                                    : item.refno.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_vm._v("物流单号")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.languageType == "EN"
                                    ? item.logisticsNo.en
                                    : item.logisticsNo.cn
                                ) +
                                "\n                "
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _vm.inOrderList.length > 0
              ? _c("div", { staticClass: "mobile_submit_bottom" }, [
                  _c(
                    "div",
                    { staticClass: "mobile_submit_man" },
                    [
                      _c("div", { staticClass: "mobile_submit_contact" }, [
                        _vm._v("提交人")
                      ]),
                      _vm._v(" "),
                      _c("el-input", { attrs: { placeholder: "请填写提交人" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mobile_submit_btns" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.submitFormVal(false)
                            }
                          }
                        },
                        [_vm._v("保存")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.submitFormVal(true)
                            }
                          }
                        },
                        [_vm._v("确认并提交")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warehouse_Mobile_warning" }, [
      _c("i", {
        staticClass: "el-icon-warning",
        staticStyle: { color: "#ee3330" }
      }),
      _vm._v(
        "\n      注意:请务必认真填写货值并提交确认,此信息具有法律效应!\n    "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f696712e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f696712e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodsValue/warehouseReceipt.vue
// module id = null
// module chunks = 